// extracted by mini-css-extract-plugin
module.exports = {"iconImg":"icon-img-module--iconImg--3f2cP"};